import * as React from 'react';
import ReactPullToRefresh from 'react-simple-pull-to-refresh';
import { useTheme } from '../../contexts/theme';

export interface Props {
  children: React.ReactNode;
  onRefresh: () => Promise<unknown>;
}

/**
 * <PullToRefresh> component
 * We might try this lib after updating to React 18: https://github.com/bryaneaton13/react-pull-to-refresh
 */
const PullToRefresh: React.FunctionComponent<Props> = ({
  children,
  onRefresh,
}) => {
  const { theme } = useTheme();
  return (
    <ReactPullToRefresh onRefresh={onRefresh} pullingContent="">
      <>
        <style>{`.lds-ellipsis div { background: ${theme.color.primary}; }`}</style>
        {children}
      </>
    </ReactPullToRefresh>
  );
};

export default PullToRefresh;
